<template>
  <div class="-ml-1 mb-3 flex">
    <NavButton class="mb-10" :label="t('common.back')" reversed @click="emit('back')" />

    <!-- we add the div below to not handle click on non button area -->
    <div class="flex-grow"></div>
  </div>
</template>

<script setup lang="ts">
import { t } from "@/locales/vue";

import NavButton from "@/features/questionnaire/components/NavButton/NavButton.vue";

const emit = defineEmits<{
  (event: "back"): void;
}>();
</script>

<style lang="scss" scoped></style>
